import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step1 = ({
  sra,
  setSra,
  setStep,
  storedUser,
  fileNames,
  setFileNames,
}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    // Title
    if (isEmpty(data.title)) {
      newErrors.title = "Title is required";
    }

    // Scheme Name
    if (isEmpty(data.schemeName)) {
      newErrors.schemeName = "Scheme Name is required";
    }

    // Date
    if (!data.date) {
      newErrors.date = "Date is required";
    }

    // Scheme Owner
    if (isEmpty(data.schemeOwner)) {
      newErrors.schemeOwner = "Scheme Owner is required";
    }

    // Partners
    if (isEmpty(data.partners)) {
      newErrors.partners = "Partners field is required";
    }

    // Duration
    if (isEmpty(data.duration)) {
      newErrors.duration = "Duration is required";
    }

    // Objective
    if (isEmpty(data.objective)) {
      newErrors.objective = "Objective is required";
    }

    // Type
    if (isEmpty(data.type)) {
      newErrors.type = "Type is required";
    }

    // Overview
    if (isEmpty(data.overview)) {
      newErrors.overview = "Overview is required";
    }

    // ROI
    if (isEmpty(data.roi)) {
      newErrors.roi = "ROI is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/approval/dashboard");
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Trade Marketing Scheme</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "20%" }}></span>
      </div>
      <div className="dashboard-container">
        <Typography className="form-title">Details</Typography>

        <Grid2 container columnSpacing={2}>
          {/* Title */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="title">
              Title <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              onChange={handleChange}
              value={sra?.title || ""}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </Grid2>

          {/* Scheme Name */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="schemeName">
              Scheme Name <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.schemeName && "input-error"}`}
              type="text"
              name="schemeName"
              id="schemeName"
              onChange={handleChange}
              value={sra?.schemeName || ""}
            />
            {errors.schemeName && <p className="error">{errors.schemeName}</p>}
          </Grid2>

          {/* Date */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="date">
              Request Date <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.date && "input-error"}`}
              type="date"
              name="date"
              id="date"
              onChange={handleChange}
              value={
                sra?.date ? new Date(sra.date).toISOString().split("T")[0] : ""
              }
            />
            {errors.date && <p className="error">{errors.date}</p>}
          </Grid2>

          {/* Scheme Owner */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="schemeOwner">
              Scheme Owner (Persom Submitting Proposal){" "}
              <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.schemeOwner && "input-error"}`}
              type="text"
              name="schemeOwner"
              id="schemeOwner"
              onChange={handleChange}
              value={sra?.schemeOwner || ""}
            />
            {errors.schemeOwner && (
              <p className="error">{errors.schemeOwner}</p>
            )}
          </Grid2>

          {/* Partners */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="partners">
              Target Partners <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.partners && "input-error"}`}
              type="text"
              name="partners"
              id="partners"
              onChange={handleChange}
              value={sra?.partners || ""}
            />
            {errors.partners && <p className="error">{errors.partners}</p>}
          </Grid2>

          {/* Duration */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="duration">
              Scheme Duration <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.duration && "input-error"}`}
              type="text"
              name="duration"
              id="duration"
              onChange={handleChange}
              value={sra?.duration || ""}
            />
            {errors.duration && <p className="error">{errors.duration}</p>}
          </Grid2>

          {/* Objective */}
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="objective">
              Scheme Objective <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.objective && "input-error"}`}
              name="objective"
              id="objective"
              onChange={handleChange}
              value={sra?.objective || ""}
              rows={2}
            />
            {errors.objective && <p className="error">{errors.objective}</p>}
          </Grid2>

          {/* Type */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="type">
              Type of Scheme <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.type && "input-error"}`}
              type="text"
              name="type"
              id="type"
              onChange={handleChange}
              value={sra?.type || ""}
            />
            {errors.type && <p className="error">{errors.type}</p>}
          </Grid2>

          {/* Overview */}
          <Grid2 size={{ xs: 12, sm: 12 }}>
            <label htmlFor="overview">
              Financial Overview <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <textarea
              className={`${errors.overview && "input-error"}`}
              name="overview"
              id="overview"
              rows={2}
              onChange={handleChange}
              value={sra?.overview || ""}
            />
            {errors.overview && <p className="error">{errors.overview}</p>}
          </Grid2>

          {/* ROI */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="roi">
              ROI Projection <span style={{ color: "#FF0000" }}>*</span>
            </label>
            <input
              className={`${errors.roi && "input-error"}`}
              type="text"
              name="roi"
              id="roi"
              onChange={handleChange}
              value={sra?.roi || ""}
            />
            {errors.roi && <p className="error">{errors.roi}</p>}
          </Grid2>
        </Grid2>
      </div>

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step1;
